/**
 * SCAN PAGE
 * Dedicated Full-Screen Scanner
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { venuesAPI } from '../api';
import QRScanner from '../components/QRScanner';
import BottomNav from '../components/BottomNav';
import LoadingSpinner from '../components/LoadingSpinner';

export default function ScanPage() {
    const [checkinResult, setCheckinResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleScanSuccess = async (token) => {
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                try {
                    const res = await venuesAPI.submitCheckin(token, position.coords.latitude, position.coords.longitude);
                    setCheckinResult({ success: true, message: res.data.message });
                    // Redirect to profile after short delay
                    setTimeout(() => window.location.href = '/profile', 2000);
                } catch (err) {
                    setCheckinResult({ 
                        success: false, 
                        message: err.response?.data?.message || err.response?.data?.error || 'Check-in failed' 
                    });
                } finally {
                    setLoading(false);
                }
            },
            () => {
                setCheckinResult({ success: false, message: 'Location access required. Please enable GPS and try again.' });
                setLoading(false);
            },
            { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
    };

    if (loading) return <LoadingSpinner />;

    return (
        <div style={styles.screen}>
            <div style={styles.header}>
                <h1 style={styles.title}>Scan Venue QR</h1>
                <p style={styles.subtitle}>Point your camera at the Copper Road QR code</p>
            </div>

            <div style={styles.scannerWrapper}>
                <QRScanner onScanSuccess={handleScanSuccess} onClose={() => navigate(-1)} />
            </div>

            {checkinResult && (
                <div style={{ ...styles.toast, background: checkinResult.success ? '#2e7d32' : '#c62828' }}>
                    {checkinResult.success ? '🏅 ' : '⚠️ '}{checkinResult.message}
                </div>
            )}

            <div style={{ height: 80 }} /> {/* Spacer for BottomNav */}
            <BottomNav active="/scan" />
        </div>
    );
}

const styles = {
    screen: { 
        background: '#1a2234', 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column',
        position: 'relative',
        overflowX: 'hidden'
    },
    header: { padding: '40px 20px 20px', textAlign: 'center' },
    title: { color: '#fff', fontSize: 24, fontFamily: 'Georgia, serif', margin: 0, fontWeight: 'bold' },
    subtitle: { color: '#8899aa', fontSize: 13, marginTop: 8, opacity: 0.8 },
    scannerWrapper: { 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center',
        paddingBottom: 20
    },
    toast: { 
        position: 'fixed', bottom: 100, left: 20, right: 20, 
        padding: 16, borderRadius: 12, color: '#fff', zIndex: 1000, 
        textAlign: 'center', fontWeight: 'bold', border: '1px solid rgba(255,255,255,0.2)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
        animation: 'slideUp 0.3s ease-out'
    }
};
